
<ngx-org-chart [nodes]="orgChartData" direction="vertical" ></ngx-org-chart>

 <!-- (itemClick)="test($event)" -->